'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("taelParameters", function ($http) {
  return {
    getParameters: function getParameters() {
      return $http.get('/rest/tael-params').then(function (response) {
        return response.data;
      });
    },
    saveParameters: function saveParameters(paramMap) {
      return $http.post('/rest/tael-params', paramMap);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/taelParameters.js
// module id = 2880
// module chunks = 13